import { styled } from 'styled-components';

export function DropDownAsyncSearchHelper() {
    return (
        <StyledContainer>
            <Paragraph>Sorry, we hebben geen resultaten gevonden.</Paragraph>
            <Paragraph $bold>Zoekhulp</Paragraph>
            <Paragraph>
                <StyledSpan>•</StyledSpan> Typ 1 diagnose en kies uit de lijst
            </Paragraph>
            <Paragraph>
                <StyledSpan>•</StyledSpan> Gebruik kortere zoektermen
            </Paragraph>
        </StyledContainer>
    );
}

const StyledSpan = styled.span`
    font-weight: bold;
`;

const StyledContainer = styled.div`
    text-align: left;
`;

const Paragraph = styled.p<{ $bold?: boolean }>`
    margin: 0;
    font-weight: ${(props) => (props.$bold ? 'bold' : 'normal')};
`;
